import { A2ATransfersTransactionKind } from '@dock/types-dock-partner';

import { ChipColors } from '../../../common';

export const a2aTransferTXKindColorMap: Record<A2ATransfersTransactionKind, ChipColors> = {
    Pull: ChipColors.warning,
    Push: ChipColors.success,
};
